
import React from "react";
const ProgressBar = ({ currentStep, totalSteps, icons }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
            {icons.map((icon, index) => {
                const isActive = index  < currentStep;
                const isCurrent = index === currentStep - 1;

                return (
                    <React.Fragment key={index}>
                        <div
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: isActive ? '#f6b5d3' : '#e0e0e0',
                                color: isActive ? 'white' : '#9e9e9e',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: isCurrent ? '2px solid #2E7D32' : 'none',
                                transition: 'all 0.3s ease',
                                zIndex: 2,
                            }}
                        >
                            {icon}
                        </div>
                        {index < icons.length - 1 && (
                            <div
                                style={{
                                    flex: 1,
                                    height: '4px',
                                    backgroundColor: isActive ? '#f6b5d3' : '#e0e0e0',
                                    margin: '0 -10px',
                                    transition: 'all 0.3s ease',
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};
export default ProgressBar;



// F6B5D3FF